<template>
  <v-row>
    <v-col cols="12" md="12">
      <v-data-table id="paymentHistoryTable" sytle="width: 100%" :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" hide-default-footer :headers="headers" :items="paymenteHistoryList" :no-data-text="noDataText" :hide-default-header="isMobile">
        <template v-slot:item.purchased_at="{ item }">
          <div>{{ parsePaymentDate(item.purchased_at) }}</div>
        </template>
        <template v-slot:item.invoice_id="{ item }">
          <v-btn color="primary" text @click.native.stop.prevent="resendInvoice(item.invoice_id)">
            Resend
          </v-btn>
        </template>
      </v-data-table>
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </v-col>
    <!-- Modal to show request result -->
    <ResultModal :isModalOpen="isResultModalOpen" :success="isResendInvoiceSuccess" :successMsgSubtitle="resendInvoiceSuccessMsgSubtitle" :failedMsgSubtitle="resendInvoiceFailedMsgSubtitle" :successActions="resendInvoiceSuccessActions" :failedActions="resendInvoiceFailedActions" />
  </v-row>
</template>

<script>
  import ResultModal from "@/components/ResultModal";

  export default {
    name: "PaymentHistory",

    data() {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        headers: [
          {
            text: "ID",
            value: "id",
            sortable: false,
          },
          {
            text: "Date",
            value: "purchased_at",
            sortable: false,
            align: "center",
          },
          {
            text: "Invoice",
            value: "invoice_id",
            sortable: false,
            align: "center",
          },
        ],
        paymenteHistoryList: [],
        noDataText: "No Payment History Records",
        isResultModalOpen: false,
        isResendInvoiceSuccess: false,
        resendInvoiceSuccessMsgSubtitle: "You should receive the invoice soon, please check your email.",
        resendInvoiceFailedMsgSubtitle: undefined,
        resendInvoiceSuccessActions: [
          {
            name: "Done",
            event: this.toggleResultModal,
          },
        ],
        resendInvoiceFailedActions: [
          {
            name: "Try Again",
            event: this.toggleResultModal,
          },
        ],
      };
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
    },

    components: { ResultModal },

    methods: {
      parsePaymentDate(date) {
        return this.$moment(date).format("YYYY-MM-DD");
      },

      toggleResultModal() {
        this.isResultModalOpen = !this.isResultModalOpen;
      },

      resendInvoice(invoiceId) {
        if (!this.$validator.isEmpty(invoiceId)) {
          //TODO: integrate resend invoice api
          this.$store.commit("setLoadingStatus", true);

          this.isResendInvoiceSuccess = true;
          this.isResultModalOpen = true;
          this.$store.commit("setLoadingStatus", false);
        } else {
          this.isResendInvoiceSuccess = false;
          this.isResultModalOpen = true;
          this.resendInvoiceFailedMsgSubtitle = "Could not find invoice ID";
        }
      },
    },

    created() {
      this.$store.commit("setLoadingStatus", true);

      this.$http
        .get("/payments")
        .then((response) => {
          this.paymenteHistoryList = response.data.payments;

          this.$store.commit("setLoadingStatus", false);
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("setError", {
            message: this.$formatter.getErrorMsg(error),
            type: "error",
          });
          this.$store.commit("setLoadingStatus", false);
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Payment/PaymentHistory.vue